// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"aVyUX","container":"_10x6h","buttonWrapper":"_1PNkO","button":"_3pcIy"};


//////////////////
// WEBPACK FOOTER
// ./app/components/button-group/button-group.scss
// module id = 633
// module chunks = 3 4 5 6 7